<div class="relative flex flex-col w-80 overflow-hidden">
    <img src="../../../assets/images/logo.svg" alt="Logo TeatroColosseo" class="w-full">
    <div class="loadline"></div>
</div>